"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var styles_1 = require("@mui/material/styles");
var Box_1 = __importDefault(require("@mui/system/Box"));
var CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
var WarningAmber_1 = __importDefault(require("@mui/icons-material/WarningAmber"));
var material_1 = require("@mui/material");
var Button = __importStar(require("./A_Button"));
var Component = function (p) {
    var styles = (0, makeStyles_1.default)({
        noHover: {
            '&:hover': {
                backgroundColor: p.colour,
                color: p.colour,
            },
        },
    });
    var theme = (0, styles_1.useTheme)();
    var buttonStyle = styles();
    return (Preact.h(Box_1.default, { flexDirection: "column", display: "flex", alignItems: "center", gap: "12px" },
        Preact.h(Box_1.default, { sx: {
                borderRadius: '4px',
                borderColor: theme.palette.info.light,
                borderWidth: p.active ? '1px' : '0px',
                borderStyle: 'solid',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '90px',
                height: '90px',
                flexShrink: 0,
                padding: '6px',
            } },
            Preact.h(Button.Component, { sx: {
                    width: '100%',
                    height: '100%',
                    backgroundColor: p.colour,
                    borderRadius: '4px',
                    padding: 0,
                }, className: buttonStyle.noHover, onClick: p.onClick },
                Preact.h("img", { src: p.image, style: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '4px',
                    } }),
                p.active && (Preact.h(Preact.Fragment, null,
                    Preact.h(Box_1.default, { sx: {
                            position: 'absolute',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '24px',
                            height: '24px',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                        } }),
                    Preact.h(CheckCircle_1.default, { color: "success", sx: {
                            position: 'absolute',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '34px',
                            height: '34px',
                        } }))),
                p.warning && !p.active && (Preact.h(WarningAmber_1.default, { sx: {
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: '34px',
                        height: '34px',
                        color: 'white',
                    } })))),
        Preact.h(material_1.Typography, { variant: "body2" }, p.label)));
};
exports.Component = Component;
